// extracted by mini-css-extract-plugin
export default {"heading":"SchoolTrainingPlansPage_heading__NmX6+","pagination":"SchoolTrainingPlansPage_pagination__fJmpG","headingContainer":"SchoolTrainingPlansPage_headingContainer__vare-"};